import { Modal } from "@/components/ui/Modal";
import { formatSoldOutNightGerman } from "@/lib/soldOutDates";

type PastSoldOutNightsModalProps = {
  open: boolean;
  onClose: () => void;
  pastNights: string[];
};

export function PastSoldOutNightsModal({
  open,
  onClose,
  pastNights,
}: PastSoldOutNightsModalProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Vergangene ausgebuchte Nächte"
      description="Diese Tage liegen in der Vergangenheit und können hier nur eingesehen werden."
      size="md"
    >
      {pastNights.length > 0 ? (
        <ul className="space-y-1 text-sm">
          {pastNights.map((iso) => (
            <li
              key={iso}
              className="rounded-lg border border-separator px-3 py-2 text-label"
            >
              {formatSoldOutNightGerman(iso)}
            </li>
          ))}
        </ul>
      ) : (
        <p className="text-sm text-label-secondary">Keine vergangenen Nächte hinterlegt.</p>
      )}
    </Modal>
  );
}
